import React from 'react'

export const DownloadFolder = props => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0_1338_7600)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4 10C4 7.79086 5.79086 6 8 6H19.0388C20.2538 6 21.4032 6.55236 22.1622 7.50122L24.9612 11H40C42.2092 11 44 12.7909 44 15V38C44 40.2092 42.2092 42 40 42H8C5.79086 42 4 40.2092 4 38V10ZM24 20C25.1046 20 26 20.8954 26 22V27.417L26.8284 26.5886C27.6094 25.8074 28.8758 25.8074 29.6568 26.5886C30.438 27.3696 30.438 28.6358 29.6568 29.417L25.4142 33.6596C24.6332 34.4406 23.3668 34.4406 22.5858 33.6596L18.3431 29.417C17.5621 28.6358 17.5621 27.3696 18.3431 26.5886C19.1242 25.8074 20.3906 25.8074 21.1716 26.5886L22 27.417V22C22 20.8954 22.8954 20 24 20Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_1338_7600">
        <rect width="48" height="48" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
